import api from "./api";

export function getStudyProgramPage(country_id) {
  return api.get(`/studypage/${country_id}`);
}
